import { Eyebrow } from "@/components/ui-custom/Eyebrow";
import { SITE } from "@/data/site";
import { useSEO } from "@/lib/seo";

const Section = ({ id, title, children }) => (
  <div id={id} className="mb-14 scroll-mt-24" data-testid={`legal-${id}`}>
    <h2 className="h3" style={{ fontSize: "26px", color: "var(--text-dark)" }}>{title}</h2>
    <div className="mt-4 space-y-4 text-muted-warm" style={{ fontSize: "16px", lineHeight: 1.7 }}>
      {children}
    </div>
  </div>
);

export default function Legal() {
  useSEO({
    title: "Privacy Policy & Terms | AIM High",
    description: "Privacy Policy and Terms of Use for AIM High.",
    path: "/legal",
    noindex: true,
  });

  return (
    <section className="sec-offwhite section-y" data-testid="legal-page" style={{ minHeight: "70vh" }}>
      <div className="container-1200" style={{ maxWidth: "820px" }}>
        <Eyebrow start>Legal</Eyebrow>
        <h1 className="h1 mt-5" style={{ fontSize: "40px" }}>Privacy Policy &amp; Terms</h1>
        <p className="mt-4 text-muted-warm" style={{ fontSize: "15px" }}>Last updated: 2026</p>

        <div className="divider-gold my-10" />

        <Section id="privacy" title="Privacy Policy">
          <p>
            This Privacy Policy explains how {SITE.name} ("we," "us," or "our") handles the information you share with us through this website. We keep it simple: we only collect what we need to help you with your project.
          </p>
          <p>
            <strong>What we collect.</strong> When you submit our contact or estimate form, we collect the details you provide — such as your name, phone number, email address, project type, location, budget range, and any project details you choose to share.
          </p>
          <p>
            <strong>How we use it.</strong> We use your information solely to respond to your request, prepare an estimate, schedule a walkthrough, and communicate with you about your project. That's it.
          </p>
          <p>
            <strong>We don't sell your data.</strong> We do not sell, rent, or trade your personal information to anyone. We only share information with service providers that help us operate (for example, email delivery), and only as needed to respond to you.
          </p>
          <p>
            <strong>Cookies.</strong> This website may use basic cookies or similar technology to help the site function and to understand general usage. You can control cookies through your browser settings.
          </p>
          <p>
            <strong>Your choices.</strong> You can request that we update or delete the information you've submitted at any time by contacting us at {SITE.email} or {SITE.phone}.
          </p>
        </Section>

        <Section id="terms" title="Terms of Use">
          <p>
            By using this website, you agree to these Terms of Use. The content here is provided for general information about {SITE.name} and our services.
          </p>
          <p>
            <strong>No guarantee of results.</strong> Information on this site, including any descriptions of services, timelines, or pricing ranges, is general in nature. Actual project scope, schedule, and cost are defined in a written estimate and agreement specific to your project.
          </p>
          <p>
            <strong>Estimates.</strong> Submitting a form does not create a contract. A project begins only once a written estimate is reviewed and approved by you.
          </p>
          <p>
            <strong>Intellectual property.</strong> All content on this site, including text, logos, and images, is the property of {SITE.name} and may not be copied or reused without permission.
          </p>
          <p>
            <strong>Contact.</strong> Questions about these terms? Reach us at {SITE.email} or {SITE.phone}, or by mail at {SITE.address.full}.
          </p>
        </Section>
      </div>
    </section>
  );
}
